<div class="product-root" *transloco="let t">
  <div class="header">
    <div class="name">
      {{ labels.productName }}
    </div>
    <span>{{ labels.productHeaders }}</span>
    <span>{{ labels.productRewards }}</span>
  </div>
  <div class="divider"></div>
  <div
    class="product-list"
    *ngIf="feedItems.length && !loading"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    [scrollWindow]="false"
    [immediateCheck]="true"
    (scrolled)="pullProducts()"
  >
    <div *ngFor="let item of feedItems">
      <app-product-list-item [productData]="item" (editProduct)="goToProductEdit($event)"></app-product-list-item>
    </div>
    <div class="loading-more-items">
      <mat-spinner diameter="15" *ngIf="pulling"></mat-spinner>
    </div>
    <div *ngIf="loading" class="loading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </div>
  <div class="product-list" *ngIf="feedItems.length === 0 && loading">
    <div *ngFor="let item of mockedProducts">
      <app-product-list-item [productData]="item"></app-product-list-item>
    </div>
    <div class="loading-more-items">
      <mat-spinner diameter="15" *ngIf="pulling"></mat-spinner>
    </div>
    <div *ngIf="loading" class="loading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </div>
  <div *ngIf="feedItems.length === 0 && !loading" class="no-items">
    <nb-icon icon="people-outline"></nb-icon>
    <h2>{{ t('empty-control-panel') }}</h2>
    <div>{{ t('empty-control-panel-2') }}</div>
  </div>
</div>
